<template>
    <Modal
        :dark="true"
        @close="close"
        @download="downloadCertificate"
        :actions="modalActions"
        ref="modal"
    >
        <transition name="fade" mode="out-in">
            <ListPlaceholder
                v-if="!initLoading && error"
                :title="'Coś poszło nie tak'"
            />
            <ListLoader v-if="initLoading && !error" />
            <div v-if="!initLoading && !error" style="height: 100%">
                <div v-if="isExamFinished && isCertificatePaid">
                    <div
                        style="
                            display: flex;
                            justify-content: center;
                            width: 100%;
                        "
                    >
                        <pdf
                            class="preview-pdf"
                            :src="$Utils.convertImageUrl(certificate)"
                        ></pdf>
                    </div>
                </div>
                <div
                    v-if="!isExamFinished && !examStarted && isCertificatePaid"
                >
                    <h2>
                        Aby otrzymać certyfikat, należy ukończyć krótki test
                    </h2>
                    <div style="display: flex;">
                        <div
                            @click="examStarted = true"
                            class="vod-nav-button -border"
                        >
                            Rozpocznij test
                        </div>
                    </div>
                </div>
                <VodCertificateExam
                    @examPassed="examPassed"
                    v-if="examStarted"
                    :webinar="webinar"
                    @scroll="scrollTop"
                />
                <VodCertificatePayment
                    @logged="getCertificateStorage"
                    @scroll="scrollTop"
                    v-if="!isCertificatePaid"
                    :webinar="webinar"
                    :conferenceWebinar="conferenceWebinar"
                />
            </div>
        </transition>
    </Modal>
</template>
<script>
export default {
    components: {
        VodCertificatePayment: () => import('./VodCertificatePayment'),
        VodCertificateExam: () => import('./VodCertificateExam'),
        pdf: () => import('vue-pdf')
    },
    props: {
        webinar: { type: Object, default: () => {} },
        conferenceWebinar: { type: Object, default: () => {} }
    },
    data() {
        return {
            initLoading: true,
            error: false,
            loading: false,
            examStarted: false,
            finishedExams: {},
            certificate: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        modalActions() {
            const actions = []
            if (
                this.isExamFinished &&
                !this.initLoading &&
                this.isCertificatePaid &&
                this.certificate
            ) {
                actions.push({
                    action: 'download',
                    display: 'Pobierz certyfikat',
                    loading: this.loading,
                    color: 'apple'
                })
            }
            return actions
        },
        isCertificatePaid() {
            const boughtItems = this.$store.state.boughtItems
            return boughtItems.some(
                item =>
                    item.uuid == this.webinar.uuid ||
                    item.uuid == this.webinar.conference
            )
        },
        isExamFinished() {
            return (
                this.webinar.type == 'course' ||
                !this.webinar.exam ||
                this.webinar.exam.length == 0 ||
                (this.finishedExams && this.finishedExams[this.webinar.uuid])
            )
        }
    },
    methods: {
        scrollTop() {
            this.$refs.modal.scrollTop()
        },
        examPassed() {
            this.getCertificateStorage()
        },
        downloadCertificate() {
            this.$Network.downloadFile(this.certificate)
        },
        setDefaultStorage() {
            this.$api
                .put(`v1/storage/finishedExams`, {
                    value: {}
                })
                .then(() => {
                    this.initLoading = false
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.error = true
                })
        },
        getCertificateStorage() {
            if (!this.user.account_id) {
                this.initLoading = false
                return
            }
            this.$api
                .get(`v1/storage/finishedExams`)
                .then(({ data }) => {
                    this.finishedExams = data ? data : {}
                    this.examStarted = false
                    if (this.isExamFinished) {
                        this.checkCertificate()
                    } else {
                        this.initLoading = false
                    }
                })
                .catch(error => {
                    const status =
                        error && error.response ? error.response.status : ''
                    if (status == 404) {
                        this.setDefaultStorage()
                    } else {
                        this.$Network.handleError(error)
                        this.error = true
                        this.initLoading = false
                    }
                })
        },
        checkCertificate() {
            const currentProduct = this.$store.state.boughtItems.find(
                item =>
                    item.uuid == this.webinar.uuid ||
                    item.uuid == this.webinar.conference
            )
            if (!currentProduct) {
                this.initLoading = false
                return
            }
            this.generateCertificate(currentProduct)
        },
        async generateCertificate(currentProduct) {
            if (this.isCertificatePaid && !this.webinar.certificate_title) {
                this.close()
            }
            try {
                const user = this.$store.state.user
                const bill = await this.getBill()
                this.$moment.locale('pl')
                const date = this.$moment().format('D MMMM YYYY')
                const data = {
                    name: user.display,
                    description: this.webinar.certificate_description,
                    title: this.webinar.certificate_title,
                    host: this.webinar.certificate_host,
                    date: date,
                    uuid: this.webinar.uuid
                }
                if (!bill[0] && !currentProduct.id) {
                    this.error = true
                    this.initLoading = false
                    return
                }
                const itemId = bill[0] ? bill[0].id : currentProduct.id
                this.certificate = (
                    await this.$api.post(
                        `v1/marketplace/bills/${itemId}/certificate`,
                        data
                    )
                ).data
                await this.$apiService.getBoughtItems()
                this.initLoading = false
            } catch (error) {
                this.$Network.handleError(error)
                this.initLoading = false
            }
        },
        getBill() {
            const uuid = this.webinar.conference
                ? this.webinar.conference
                : this.webinar.uuid
            return this.$api
                .get(`v1/marketplace/bills?query=(uuid=${uuid})`)
                .then(({ data }) => {
                    return data
                })
                .catch(error => {
                    return error
                })
        },
        close() {
            this.$emit('close')
        }
    },
    mounted() {
        this.getCertificateStorage()
    },
    watch: {
        isCertificatePaid() {
            if (this.isCertificatePaid && !this.webinar.certificate_title) {
                this.close()
            }
        },
        user() {
            this.getCertificateStorage()
        }
    }
}
</script>
<style lang="scss" scoped>
.preview-pdf {
    width: 60%;
    overflow: hidden;
}
.vod-nav-button {
    cursor: pointer;
    padding: 0.4rem 1rem;
    transition: $ease;
    position: relative;

    &:hover {
        transform: translateY(0.1rem);
    }

    &.-border {
        border: solid 1px $accent-apple;
        border-radius: $minimal-radius;

        &:hover {
            background: $accent-apple;
            transform: none;
        }
    }
}
</style>
